module.exports = ".form-control[disabled], .form-control[readonly] {\n    color: #2c2c2c;\n}"